import React from "react";
import { History, ListChecks, Send } from "lucide-react";
import TabPageLayout from "modules/swiftboard/components/TabPageLayout";
import useUrlTab from "modules/swiftboard/components/useUrlTab";
import Instance from "./instance/Instance";
import Delivery from "./delivery/Delivery";
import RunLog from "./run-log/RunLog";

// What the reminder engine did: the cases it opened (tbl_rem_instance), every message (tbl_rem_delivery) and every
// rule run (tbl_rem_run_log). `slug` is the ?tab= value: keep it stable even if the label changes.
const REMINDER_MONITOR_TABS = [
  { id: 1, slug: "cases", label: "Cases", Icon: ListChecks, Page: Instance },
  { id: 2, slug: "deliveries", label: "Deliveries", Icon: Send, Page: Delivery },
  { id: 3, slug: "run-log", label: "Run Log", Icon: History, Page: RunLog },
];

const ReminderMonitor = () => {
  const [activeTab, setActiveTab] = useUrlTab(REMINDER_MONITOR_TABS.map((tab) => tab.slug));
  const tabs = REMINDER_MONITOR_TABS.map(({ id, label, Icon }) => ({ id, label, icon: <Icon size={18} /> }));
  const { slug, Page } = REMINDER_MONITOR_TABS[activeTab];

  return (
    <TabPageLayout tabs={tabs} activeTab={activeTab} onTabChange={(index) => setActiveTab(index)}>
      <Page key={slug} />
    </TabPageLayout>
  );
};

export default ReminderMonitor;
